import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function CinselTerapiPage() {
  const navigate = useNavigate();
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const problems = [
    'Cinsel yaşamla ilgili konuşmakta güçlük çekiyor musunuz?',
    'Bu konular ilişkinizi veya kendinizi olumsuz etkiliyor mu?',
    'Anlaşılmak ve yargılanmadan dinlenmek istiyor musunuz?',
    'Çözüme kavuşturulmamış sorunlar birikmekte mi?',
    'Partneri ile bu konularda iletişim kurmakta zorlanıyor musunuz?',
  ];

  const outcomes = [
    { icon: 'ri-search-line', title: 'Problemlerin kaynağını anlamak', desc: 'Sorunların nereden geldiğini güvenli bir ortamda keşfederiz.' },
    { icon: 'ri-chat-smile-2-line', title: 'İletişimi güçlendirmek', desc: 'Partnerinizle açık ve dürüst bir diyalog kurabilirsiniz.' },
    { icon: 'ri-sparkling-line', title: 'Daha sağlıklı bir ilişki kurmak', desc: 'Yargısız bir süreçte kendinizi ve ilişkinizi yeniden keşfedin.' },
  ];

  return (
    <div className="min-h-screen font-sans bg-cream">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-28 pb-16 md:pt-36 md:pb-24 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=private%20confidential%20therapy%20room%20two%20armchairs%20soft%20warm%20light%20minimal%20elegant%20decor%20neutral%20tones%20candle%20plant%20on%20table%20professional%20safe%20space%20healing%20atmosphere%20trust%20serenity&width=1440&height=700&seq=cinsel-hero-01&orientation=landscape"
              alt="Cinsel Terapi"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-warm-dark/70 via-warm-dark/50 to-warm-dark/70" />
          </div>
          <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-xs text-cream-dark/70 hover:text-gold mb-6 cursor-pointer"
            >
              <i className="ri-arrow-left-line" /> Ana Sayfaya Dön
            </button>
            <span className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-4 block border border-gold/40 inline-block px-4 py-1.5 rounded-full">
              Danışmanlık Alanı
            </span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-cream-dark mb-5 leading-snug">
              Cinsel Terapi
            </h1>
            <div className="inline-flex items-center gap-2 bg-gold/90 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5">
              <i className="ri-gift-line text-xs" />
              İlk Seans Ücretsiz
            </div>
            <p className="text-cream-dark/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-3">
              Bazı konular konuşulmadıkça büyür.
            </p>
            <p className="text-cream-dark/70 text-sm leading-relaxed max-w-xl mx-auto mb-8 italic">
              Bu süreçte yalnız değilsiniz.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => scrollTo('randevu-cta')}
                className="px-7 py-3.5 bg-gold text-white text-sm font-medium rounded-full hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap"
              >
                Randevu Al
              </button>
              <button
                onClick={() => scrollTo('surec')}
                className="px-7 py-3.5 border border-white/30 text-cream-dark text-sm font-medium rounded-full hover:border-gold hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
              >
                Süreci Keşfet
              </button>
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="py-16 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-serif text-3xl font-light text-warm-dark mb-5">Güvenli, gizli ve yargısız bir alan</h2>
              <p className="text-warm-mid text-sm leading-relaxed mb-4">
                Cinsel yaşamla ilgili yaşanan problemler çoğu zaman dile getirilmez… Ancak bu durum hem ilişkiyi hem de bireyin kendini etkileyebilir.
              </p>
              <p className="text-warm-mid text-sm leading-relaxed mb-6">
                Cinsel terapi süreci; güvenli, gizli ve yargısız bir ortamda yaşanan sorunları ele almayı ve çözüm üretmeyi amaçlar.
              </p>
              <div className="grid grid-cols-2 gap-3">
                {['Tam gizlilik', 'Yargısız yaklaşım', 'Güvenli alan', 'Bilimsel yöntem'].map(b => (
                  <div key={b} className="flex items-center gap-2 bg-cream rounded-lg px-3 py-2.5 text-xs text-warm-mid">
                    <i className="ri-checkbox-circle-fill text-gold" /> {b}
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden h-72 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=intimate%20private%20elegant%20therapy%20office%20warm%20candle%20light%20soft%20beige%20linen%20couch%20plant%20window%20minimal%20decor%20confidential%20safe%20space%20healing%20professional%20serene%20atmosphere&width=700&height=500&seq=cinsel-sec1-01&orientation=landscape"
                alt="Cinsel Terapi Süreci"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>

        {/* Outcomes */}
        <section id="surec" className="py-16 md:py-20 bg-cream">
          <div className="max-w-4xl mx-auto px-4 md:px-8 text-center mb-12">
            <h2 className="font-serif text-3xl font-light text-warm-dark mb-3">Bu süreçte neler kazanabilirsiniz?</h2>
            <p className="text-warm-mid text-sm max-w-xl mx-auto">Terapi süreci boyunca birlikte çalışacağımız alanlar:</p>
          </div>
          <div className="max-w-4xl mx-auto px-4 md:px-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {outcomes.map((o) => (
              <div key={o.title} className="bg-white rounded-2xl p-7 flex flex-col items-center text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gold/10 mb-4">
                  <i className={`${o.icon} text-gold text-xl`} />
                </div>
                <h3 className="font-serif text-base font-medium text-warm-dark mb-2">{o.title}</h3>
                <p className="text-warm-mid text-xs leading-relaxed">{o.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Problems */}
        <section className="py-16 md:py-20 bg-white">
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <h2 className="font-serif text-3xl font-light text-warm-dark text-center mb-3">Bu durum size tanıdık geliyor mu?</h2>
            <p className="text-warm-mid text-sm text-center mb-10">Bu sorulardan biri sizi düşündürüyorsa, birlikte konuşmak için buradayız.</p>
            <div className="flex flex-col gap-3">
              {problems.map((p, i) => (
                <div key={i} className="flex items-start gap-4 bg-cream rounded-xl px-5 py-4 border border-cream-deeper">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gold/10 flex-shrink-0 mt-0.5">
                    <i className="ri-question-line text-gold text-xs" />
                  </span>
                  <p className="text-sm text-warm-mid">{p}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section id="randevu-cta" className="py-20 bg-warm-dark text-center">
          <div className="max-w-2xl mx-auto px-4 md:px-8">
            <h2 className="font-serif text-3xl md:text-4xl font-light text-cream-dark mb-4">
              İlk adımı atmak cesarettir
            </h2>
            <p className="text-warm-pale/70 text-sm mb-8">Her şey gizlilik içinde kalır. İlk görüşme ücretsizdir.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/#randevu')}
                className="px-8 py-3.5 bg-gold text-white text-sm font-medium rounded-full hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap"
              >
                Randevu Al
              </button>
              <a
                href="https://wa.me/905309042429"
                target="_blank"
                rel="nofollow noreferrer"
                className="px-8 py-3.5 border border-white/20 text-cream-dark text-sm font-medium rounded-full hover:border-gold hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
              >
                Bilgi Almak İstiyorum
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
